// https://vuex.vuejs.org/en/actions.html
import axios from 'axios'
// import NotificationTemplate from '@/pages/Notifications/NotificationTemplate'
import cookies from 'vue-cookies'

// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  login ({ commit, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      axios.post('/token', { username: userData.username, password: userData.password })
        .then(response => {
          const token = response.data.access_token
          // const user = response.data.username
          // console.log(response)
          // storing jwt in localStorage. https cookie is safer place to store

          cookies.set('token', token, '1d', '/', process.env.VUE_APP_API_COOKIE_DOMAIN || '.lfstraining.com')
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          commit('auth_success', { token })
          axios.get('/users/me').then(response => {
            var user = response.data
            // mutation to change state properties to the values passed along
            commit('auth_success', { token, user })
            localStorage.setItem('user', JSON.stringify(response.data))
            // window.location.href = '/users'
            resolve(response)
          })
          dispatch('autoRefreshToken')
            .then(r => {
              resolve(r)
            })
            .catch(e => {
              console.log(e)
              reject(e)
            })
          resolve(response)
        })
        .catch(err => {
          console.log('login error')
          commit('auth_error')
          cookies.remove('token')
          reject(err)
        })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
      // localStorage.removeItem('token')
      resolve()
    })
  },
  refreshtoken ({ commit }) {
    axios.get('/token/refresh')
      .then(response => {
        const token = response.data.access_token
        cookies.set('token', token, '1d', '/', process.env.VUE_APP_API_COOKIE_DOMAIN || '.lfstraining.com')
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        commit('auth_success', { token })
      })
      .catch(error => {
        console.log('refresh token error')
        commit('logout')
        cookies.remove('token')
        console.log(error)
      })
  },
  getTableList ({ commit }, tableName) {
    this.$http.get(`/${tableName}`)
      .then(response => {
        let tableList = response.data.Keys
        commit('setTableList', { tableList })
      })
      .catch(error => console.log(error))
  },
  updateTableItem ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({ url: `/${tableData.endpoint}`, method: httpmethod, data: tableData.tableItem })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  autoRefreshToken ({ commit }) {
    return new Promise((resolve, reject) => {
      setInterval(function () {
        // code goes here that will be run every 20 minutes.
        axios.get('/token/refresh')
          .then(response => {
            const token = response.data.access_token
            cookies.set('token', token, '1d', '/', process.env.VUE_APP_API_COOKIE_DOMAIN || '.lfstraining.com')
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            commit('auth_success', { token })
            resolve(response)
          })
          .catch(error => {
            console.log('refresh token error')
            console.log(error)
            this.$router.push('/')
            reject(error)
          })
      }, 1200000)
    }
    )
  }

}
